import {useAccountPicker, GetAnalyticsFn} from '../account-picker/useAccountPicker'

const TEMPLATES_PICKER_PRESELECTED_TEMPLATE = 'tpTemplate'
const PRESELECTED_TEMPLATE_ID = 'rtb-preselected-template-slug'
type UseOpenTemplatePicker = ReturnType<typeof useAccountPicker>

export type TemplateIdType = string | null
export type {GetAnalyticsFn}

function openAppDashboardWithTemplatePicker(
  templateId: TemplateIdType,
  _?: string | undefined,
  workspaceKey?: string,
) {
  if (!templateId) {
    return
  }

  window.location.href = `${
    workspaceKey ? `/s/${workspaceKey}` : ''
  }/app/dashboard/?${TEMPLATES_PICKER_PRESELECTED_TEMPLATE}=${templateId}`

  localStorage.setItem(PRESELECTED_TEMPLATE_ID, templateId)
}

export function useOpenTemplatePicker(
  templateId: TemplateIdType,
  setTemplateId: React.Dispatch<React.SetStateAction<TemplateIdType>>,
  getAnalytics: GetAnalyticsFn,
): UseOpenTemplatePicker {
  const callback = (accountId: string | undefined, workspaceKey: string | undefined) =>
    openAppDashboardWithTemplatePicker(templateId, accountId, workspaceKey)

  return useAccountPicker({
    getAnalytics,
    onAccountCancel: () => setTemplateId(null),
    onAccountError: () => openAppDashboardWithTemplatePicker(templateId),
    onAccountLoaded: callback,
    onAccountSubmited: callback,
  })
}
